export default "__VITE_ASSET__D3zyI_4P__"